import { colorIsLight } from "./colorUtils";

/*
Attempts to determine if a colorScheme is "light" or "dark".

Current implementation checks each color of the scheme, and counts if more colors are light or dark.

If we don't like the results of this, another implementation (which I found in some POC code of Oscar's)
could be to just check the "middle" color and go off of that:

colorIsLight(colorScheme[Math.floor(colorScheme.length / 2)])
*/

export function isColorSchemeLight(colorScheme) {
  if (!colorScheme || !Array.isArray(colorScheme)) return null;

  let lightCount = 0;
  let darkCount = 0;

  colorScheme.forEach((colorCode) => {
    colorIsLight(colorCode) ? lightCount++ : darkCount++;
  });

  return lightCount >= darkCount;
}
